module.exports = __webpack_public_path__ + "static/img/dress_shouzuo_default.4f7b7287.png";